import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Poi } from './types/Poi';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (poiId: number) =>
  makeCall<Poi>('GET', `${APIV2_URL}/poi/${poiId}/commercial`);
